export const CROP_COLOR = '#1FA67A';
export const WM_COLOR = '#E94B6F';
export const REGION_COLOR = '#FF3D9A';
export const REGION_RGB: readonly [number, number, number] = [0xff, 0x3d, 0x9a];
export const PICK_OK_COLOR = '#22C55E';
export const PICK_DUP_COLOR = '#F59E0B';
